import Super from 'client-portal/routes/-request/index';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestIndex extends Super {}
